define('utils',['require','ns','core/utils'],function (require) {
	'use strict';

	var ns = require('ns');

	var coreUtils = require('core/utils');

	var utils = {};

	_.extend(utils, coreUtils);
	
	utils.getDeviceWidth = function () {
	
		var deviceWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
		
		return deviceWidth;	
	};
	
	return utils;
});
